// @flow
import { Button as Btn } from '~/components/widgets';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
`;

export const Button = styled(Btn)`margin-top: 1em;`;

export const LogoContainer = styled.div`margin-bottom: 1em;`;



// WEBPACK FOOTER //
// ./src/components/error-boundary/styles.js